export default "<workspace-customization [domains]=\"domains\"></workspace-customization>\n";